import { Text } from 'dripsy';
import * as React from 'react';
const TEST_ID = 'doppio-spacer';
export const Spacer = ({ vertical, horizontal, top, right, bottom, left, width, height, }) => (React.createElement(Text, { sx: {
        flexGrow: 0,
        flexShrink: 0,
        width,
        height,
        ...(vertical && { paddingVertical: vertical }),
        ...(horizontal && { paddingHorizontal: horizontal }),
        ...(top && { paddingTop: top }),
        ...(right && { paddingRight: right }),
        ...(bottom && { paddingBottom: bottom }),
        ...(left && { paddingLeft: left }),
    }, testID: TEST_ID, "aria-hidden": true }));
Spacer.testID = TEST_ID;
//# sourceMappingURL=Spacer.js.map